import React from 'react';
import PropTypes from 'prop-types';

import Button from '@Components/Button';
import DropdownContentWrapper from '@Components/Popup/Dropdown/DropdownContentWrapper';

import './HeatmapNavigatorButton.custom.scss';


function HeatmapNavigatorButton (props) {
  const {
    toggleNavigator,
    navigatorDisabled,
  } = props;


  return (
    <div className='result-toolbar-heatmap-navigator-button'>
      <Button
        disabled={navigatorDisabled}
        onClick={() => {
          toggleNavigator();
        }}
        buttonConfig={{
          className: 'result-toolbar-heatmap-navigator-button-control',
          label: 'Navigator',
          type: 'link',
          size: 'tiny',
          e2eName: 'navigator',
        }}
        iconConfig={{
          position: 'before',
          name: 'compass',
          size: 'sm',
        }}
      />
      {
        navigatorDisabled && (
          <DropdownContentWrapper
            className='result-toolbar-heatmap-navigator-button-no-image'
            horizontalAlignment='left'
          >
            Navigator image is not available.
          </DropdownContentWrapper>
        )
      }
    </div>
  );
}

HeatmapNavigatorButton.defaultProps = {
  toggleNavigator: () => {
    Logger.error('something went wrong with toggleNavigator prop from angular');
  },
};

HeatmapNavigatorButton.propTypes = {
  toggleNavigator: PropTypes.func,
  navigatorDisabled: PropTypes.bool,
};

export default HeatmapNavigatorButton;
